import React from "react";
import { Card } from "antd";
import SecondaryButton from "../Buttons/SecondaryButton";

const CardMessage = ({
  onClick,
  icon,
  title,
  description,
  buttonTitle,
  onClickButton,
  buttonDisabled,
  className,
}) => {
  return (
    <Card
      className={`text-center shadow-lg rounded-lg ${className} ${
        onClick
          ? "hover:shadow-xl hover:bg-custom_primary/5 cursor-pointer"
          : ""
      }`}
      onClick={(e) => {
        if (
          e.target.type != "button" &&
          e.target.parentNode.type != "button" &&
          onClick
        ) {
          onClick(e);
        }
      }}
      bodyStyle={{
        flexDirection: "column",
        justifyContent: "space-between",
        display: "flex",
        height: "100%",
      }}
    >
      <div className="flex  mb-4">
        <div className="flex flex-1 justify-center py-1 px-4 leading-tight font-bold break-all">
          {title}
        </div>
      </div>

      {icon && (
        <div className="flex flex-1 justify-center items-center mb-4 leading-tight">
          {icon}
        </div>
      )}

      {description && (
        <div className="flex flex-1 justify-center mt-1 mb-4 leading-tight">
          {description}
        </div>
      )}
      {buttonTitle && (
        <SecondaryButton
          className="w-full"
          onClick={(e) => {
            if (onClickButton) {
              onClickButton(e);
            }
          }}
          disabled={buttonDisabled || false}
        >
          {buttonTitle}
        </SecondaryButton>
      )}
    </Card>
  );
};

export default CardMessage;
